<template>
	<div class="infor fl">
		<AllHeader :label="lable" :ischage="ischage" :sublabel="sublabel" :subtitle="subtitle" :year="year"
			@getvalue="getvalue" v-if="step == 1" />
		<div v-if="step == 0">
		        <div style="position:relative; " class="topnavs">
		             <el-radio-group v-model="activewtype" @input="handlewtype" >
                        <el-radio-button label="房屋建筑工程">房屋建筑</el-radio-button>
                        <el-radio-button label="土木工程">土木</el-radio-button>
                        <el-radio-button label="工业安装工程">工业</el-radio-button>
                      </el-radio-group>
		            <div style="display:flex;justify-content:center;align-items:center">
                        <span>{{bname}}</span>
                        <div class="infor-t-r" @click="toBatch" style="margin-left:20px; cursor: pointer;">
                			<span>返回批次</span>
                		</div>
                    </div>
		        </div>
		            <div style="position:relative">
		                <el-form ref="queryForm" size="small" :inline="true" label-width="68px" style="margin-top:20px;text-align:left;">
                        
                            <el-form-item  prop="dates">
                                 <el-date-picker
                                  v-model="dates"
                                  type="daterange"
                                  range-separator="至"
                                  start-placeholder="开始日期"
                                  end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item  prop="keyword">
                                <el-input style="width: 200px"
                                          v-model="keyword"
                                    placeholder="请输入申报单位名称"
                                    clearable/>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
                            </el-form-item>
                        </el-form>
                        <div style="position:absolute;right:0px;top:0px;display:flex;gap:8px;">
                            <el-button size="mini" type="primary" @click="handleDistruct">自动分配专家</el-button>
                            <el-button v-if="is_auto_distribute == 1" size="mini" type="primary" @click="handleDistructInfo">分配情况</el-button>
                        </div>
		            </div>
            <div style="width:100%;text-align:right;font-size:13px;color:#606266;" vif="total">总共 {{total}} 条记录</div>        
			<el-table :data="formlist"
                      v-loading="loading"
				:header-cell-style="{ background: '#FEF8EF', color: '#7C828A','text-align':'center'}"
				style="width: 100%; margin-top: 10px" :cell-style="{'text-align':'center'}"
                :row-class-name="getRowClassName">
				<el-table-column prop="no" label="序号" min-width="75"></el-table-column>
				<el-table-column label="状态" min-width="100">
				    <template slot-scope="scope">
                          <span :style="{color: getStatusColor(scope.row.status)}">{{ getStatusText(scope.row.status) }}</span>
                    </template>
				</el-table-column>
				<el-table-column prop="user.name" label="用户名" min-width="100"></el-table-column>
				<el-table-column prop="content.info.name" label="工法名称" min-width="100"></el-table-column>
				<el-table-column prop="content.info." label="工法完成人" min-width="100">
				    <template slot-scope="scope">
                          <span> <block v-for="(author,index) in scope.row.content.info.author_names">{{ author.name }} <block v-if="index + 1 < scope.row.content.info.author_names.length">、</block></block></span>
                    </template>
				</el-table-column>
				<el-table-column label="主审" min-width="80">
				    <template slot-scope="scope">
                          {{ scope.row.mainexpert ? scope.row.mainexpert.expert.name : '-'}}
                    </template>
				</el-table-column>
				<el-table-column  label="复审" min-width="80">
				    <template slot-scope="scope">
                          {{ scope.row.reexpert ? scope.row.reexpert.expert.name : '-'}}
                    </template>
				</el-table-column>
				<el-table-column  label="组长" min-width="80">
				    <template slot-scope="scope">
                          {{ scope.row.leader ? scope.row.leader.expert.name : '-'}}
                    </template>
				</el-table-column>
				<el-table-column  prop="created_at" label="提交时间" sortable min-width="100"></el-table-column>
				<el-table-column min-width="200" label="操作">
					<template slot-scope="scope">
                            <el-button @click="toDetail(scope.row)" size="mini" type="primary">查看详情
                            </el-button>
                             <el-button v-if="canDistribute(scope.row)" @click="toDistribute(scope.row)" type="primary" size="mini" >分配
                            </el-button>
                            <el-button v-if="canReturnBeforeDistribute(scope.row)" @click="openReturnDialog(scope.row)" type="warning" size="mini">退回</el-button>
					</template>
				</el-table-column>
			</el-table>
			<Pagetion :total="total" @getpageValue="getpageValue" class="pos-page"   :key="activewtype" />
			<div v-if="canFinishDistribute" style="margin-top:20px;">
			    <el-button
                    @click="toSetChecked()"
                    type="primary"
                    :disabled="hasReturnedApplications || hasIncompleteDistributedApplications || !hasFullyDistributedApplications">已完成分配,进入专家审核
                </el-button>
			</div>
            <el-dialog :title="'自动分配专家'" :visible.sync="auto_distribute" class="autodistribute" width="500px">
                <div class="form_right" style="width:100%;margin:0 auto;">
                    <div class="form_1">
                        <div class="form_box_content" >
                            <div class="flex" v-if="!show_distribute" style="justify-content: center;">
                                    <div class="form_tip_title" style="font-weight: bold; font-size: 20px; color: #262626;line-height: 36px;text-align: center;">即将进行自动随机分配专家的操作<br/>是否确认执行?</div>
                            </div>
                            <div v-else>
                                <div class="drtitle">当前分类数据详情</div>
                                <div class="drth">
                                    <div>专家库</div>
                                    <div>申报数据</div>
                                    <div>初审单位相同数据</div>
                                </div>
                                <div class="drtr">
                                    <div>{{dret['expert_num']}}</div>
                                    <div>{{dret['apply_num']}}</div>
                                    <div>{{dret['same_unit_num']}}</div>
                                </div>
                                <div  class="drtitle">分配结果</div>
                                <div class="drth">
                                    <div>已平均分配</div>
                                    <div>随机分配</div>
                                </div>
                                <div  class="drtr">
                                    <div>{{dret['success_num']}}</div>
                                    <div>{{dret['fail_num']}}</div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
                 <span slot="footer" class="dialog-footer" v-if="!show_distribute" style="display: flex;justify-content: center;">
                    <el-button type="default" @click="auto_distribute = false">否</el-button>
                    <el-button type="primary" @click="confirmAutoDistribute">是</el-button>
                  </span>
                  <span slot="footer" class="dialog-footer" v-else style="display: flex;justify-content: center;">
                    <el-button type="primary" @click="confirmauto">确 定</el-button>
                  </span>
            </el-dialog>
            <el-dialog title="分配专家" :visible.sync="show_row_distribute_dialog" width="500px">
                <div class="form_right" style="width:400px">
                    <div class="form_1">
                        <div class="form_box_content">
                            <div class="flex">
								<div class="my_form2">
									<div class="form_title" style="">请选择主审</div>
									<div class="form_content">
										 <el-select v-model="mainexpert" filterable placeholder="请选择" @change="handleSelectedExpert">
                                            <el-option v-if="experts.length"
                                              v-for="item in experts"
                                              :key="item.id"
                                              :label="item.name"
                                              :disabled="selectedexperts.indexOf(item.id) != -1"
                                              :value="item.id">
                                            </el-option>
                                          </el-select>
									</div>
								</div>
							</div>
							<div class="flex">
								<div class="my_form2">
									<div class="form_title" style="">请选择复审</div>
									<div class="form_long">
										<el-select v-model="reexpert" filterable placeholder="请选择" @change="handleSelectedExpert">
                                            <el-option  v-if="experts.length"
                                              v-for="item in experts"
                                              :key="item.id"
                                              :label="item.name"
                                              :disabled="selectedexperts.indexOf(item.id) != -1"
                                              :value="item.id">
                                            </el-option>
                                          </el-select>
									</div>
							    </div>
							</div>
							<!--<div class="flex">-->
							<!--	<div class="my_form2">-->
							<!--		<div class="form_title" style="">请选择组长</div>-->
							<!--		<div class="form_long">-->
							<!--				<el-select v-model="leader" filterable placeholder="请选择" @change="handleSelectedExpert">-->
       <!--                                     <el-option  v-if="batch_experts.length"-->
       <!--                                       v-for="item in batch_experts"-->
       <!--                                       :key="item.id"-->
       <!--                                       :label="item.name"-->
       <!--                                       :disabled="selectedexperts.indexOf(item.id) != -1"-->
       <!--                                       :value="item.id">-->
       <!--                                     </el-option>-->
       <!--                                   </el-select>-->
							<!--		</div>-->
							<!--	</div>-->
							<!--</div>-->
                        </div>
                    </div>
                </div>
                 <span slot="footer" class="dialog-footer" >
                    <el-button type="default" @click="show_row_distribute_dialog = false">取 消</el-button>
                    <el-button type="primary" @click="confirmDistribute">确 定</el-button>
                  </span>
            </el-dialog>
            
            <distribute-overview
              :visible.sync="showAwardBatch"
              :award_batch_id="award_batch_id"
              :wtype="wtype"
              :category-name="wtype_title"
            />
            <el-dialog title="退回材料" :visible.sync="returnDialogVisible" width="520px">
                <div style="font-size:15px;line-height:1.8;color:#303133;text-align:center;padding:12px 0;">
                    确认退回该申报材料？
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="returnDialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="submitReturn">确认退回</el-button>
                </span>
            </el-dialog>
            <el-dialog title="短信失败原因" :visible.sync="smsReasonVisible" width="520px">
                <div class="sms-reason-text">{{ smsReasonText }}</div>
                <div class="sms-reason-tip">{{ smsFailureContactTip }}</div>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="smsReasonVisible = false">知道了</el-button>
                </span>
            </el-dialog>

		</div>
		<div v-if="step==1">
			<el-table :data="temformlist"
				:header-cell-style="{ background: '#FEF8EF', color: '#7C828A','text-align':'center'}"
				style="width: 100%;" :cell-style="{'text-align':'center'}">
				<el-table-column prop="no" label="序号" min-width="75"></el-table-column>
				<el-table-column prop="user.name" label="用户名" min-width="100"></el-table-column>
				<el-table-column prop="content.info.type_of_work" label="工法类型" min-width="100"></el-table-column>
				<el-table-column prop="content.info.name" label="工法名称" min-width="100"></el-table-column>
				<el-table-column label="工法完成人" min-width="180">
				    <template slot-scope="scope">
                          <span> <block v-for="(author,index) in scope.row.content.info.author_names">{{ author.name }} <block v-if="index + 1 < scope.row.content.info.author_names.length">、</block></block></span>
                    </template>
				</el-table-column>
				<el-table-column label="主审" min-width="100">
				    <template slot-scope="scope">
                          {{ scope.row.mainexpert ? scope.row.mainexpert.expert.name : '-'}}
                    </template>
				</el-table-column>
				<el-table-column  label="复审" min-width="100">
				    <template slot-scope="scope">
                          {{ scope.row.reexpert ? scope.row.reexpert.expert.name : '-'}}
                    </template>
				</el-table-column>
				<el-table-column  label="组长" min-width="100">
				    <template slot-scope="scope">
                          {{ scope.row.leader ? scope.row.leader.expert.name : '-'}}
                    </template>
				</el-table-column>
				<el-table-column  label="状态" min-width="100" v-if="activestatus == 1">
				    <template slot-scope="scope">
                          {{ scope.row.status == 5 ? '通过' : ( scope.row.status == 6 ? '不通过' : '驳回企业修改')}}
                    </template>
				</el-table-column>
			</el-table>
			<div style="margin-top:10px;text-align:right;" v-if="isApplyAtExpired">
			    <el-button @click="openReturnDialog(curObj)" type="warning" size="mini">退回</el-button>
			</div>


			<el-tabs style="" v-model="activeName" tab-position="top">
				<el-tab-pane label="工法信息" name="first">
					<div class="form_right" style="border: 1px solid #DDD;">
					<div class="form_1" id="Contractorinfo" style="padding:0px ;margin:0px;">
						<div class="form_box_content binfobase">
							<div class="flex">
								<div class="my_form2">
									<div class="form_title" style="">工程类别</div>
									<div class="form_content">
										{{parameters.info == undefined ? '' : parameters.info.type_of_work}}
									</div>
								</div>
							</div>
							<div class="flex">
								<div class="my_form2">
									<div class="form_title" style="">专业分类</div>
									<div class="form_content">
										{{parameters.info == undefined ? '' : parameters.info.type_of_major}}
									</div>
								</div>
							</div>
							<div class="flex">
								<div class="my_form2">
									<div class="form_title" style="">工法名称</div>
									<div class="form_content">
										{{parameters.info == undefined ? '' : parameters.info.name}}
									</div>
								</div>
							</div>
							<div class="flex">
								<div class="my_form2">
									<div class="form_title" style="">编写单位</div>
									<div class="form_content">
										{{parameters.info == undefined ? '' : parameters.info.unit}}
									</div>
								</div>
							</div>
							<div class="flex">
								<div class="my_form2">
									<div class="form_title" style="">企业注册地</div>
									<div class="form_content">
										{{getGongfaRegisterProvince(parameters.info, curObj)}}
									</div>
								</div>
							</div>
							<div class="flex">
								<div class="my_form2">
									<div class="form_title" style="">工法完成人</div>
									<div class="form_content">
										{{formatGongfaAuthors(parameters.info)}}
									</div>
								</div>
							</div>
							<div class="flex">
								<div class="my_form2">
									<div class="form_title" style="">申报联系人/联系电话</div>
									<div class="form_content">
										{{parameters.info == undefined ? '' : parameters.info.username+'/'+parameters.info.phone}}
									</div>
								</div>
							</div>
						</div>
					</div>
					</div>
				</el-tab-pane>
				<el-tab-pane label="文件审核" name="second">
					<el-table :data="temUnitlist"
						:header-cell-style="{ background: '#F5F6F7', color: '#808895','text-align':'center'}"
						style="width: 100%;" :cell-style="{'text-align':'center'}">
						<el-table-column prop="" label="序号" min-width="40">
							<template slot-scope="scope">
							     <span v-text="getIndex(scope.$index)"> </span>
							</template>
						</el-table-column>
						<el-table-column prop="name" label="文件" show-overflow-tooltip min-width="200"></el-table-column>
						<el-table-column min-width="100" label="操作">
							<template slot-scope="scope">
							    <a class="a01" :href="scope.row.url" target="_blank">查看详情</a>
							</template>
						</el-table-column>
					</el-table>
                   
				</el-tab-pane>
				
				
			</el-tabs>
			
		</div>
	</div>
</template>

<script>
	import AllHeader from "@/components/Modal/AllHeader";
	import Pagetion from "@/components/Modal/Pagetion";
	import DistributeOverview from "@/components/DistributeOverview";
	import {
		expertaward, //专家端审核奖项列表=
		expertverify, //专家端审核是否通过
        getExpert,
        setExpert,//设置专家
       AwardBatches,
       avgdistruct,
       batchinfo,
       getBatchWtypeExperts,
       gfdistribute,
       setexpertchecked,
       getdistributeinfo,
       adminRejectAwardLog,
       getReturnSmsReason
	} from "../utils/api.js";
	export default {
		components: {
			AllHeader,
			Pagetion,
			DistributeOverview
		},
		data() {
			return {
                loading:true,
                download:false,
				dialogVisible: false,
                dialogUnitVisible: false,
                dialogTableVisible:false,
                dialogZJVisible:false,
				step: 0,
                timeRange: '',
                exportType:1,
				ischage: false,
				lable: "分配专家",
				pageSize: 10,
				total: 0,
				awardList: [],
				sublabel: "返回列表",
				subtitle: "", //副标题
				formlist: [],
				temformlist: [],
				temUnitlist:[],//参加单位信息
				temFilelist:[],//申报登记表需补充内容
                temRecommandlist:[],//推荐表
                temSupplementlist:[],
                zjlist:[],
                zjId:[],
                unit:{},//参加单位信息
				user: {},
				id: '',
				reason: "",
				year: null,
				activeName: "first",
				parameters:{"Contractorinfo":{},"SupplementaryContent":{}},
                keyword:'',
                searchYear:'',
                searchstatus:'1',
                award_id:0,
				curObj: {}, // 当前点击的行
				isShowAssignGroup: false,
				reAssign: false,
                batches:[],
                checkedlogs:[],
                created_at:'',
                activewtype:'房屋建筑工程',
                dates:null,
                auto_distribute:false,
                award_batch_id:0,
                dret:{},
                show_distribute:false,
                is_auto_distribute:0,
                batchinfo:null,
                show_row_distribute_dialog:false,
                experts:[],
                selectedexperts:[],
                leader:0,
                mainexpert:0,
                reexpert:0,
                same_unit_experts:[],
                batch_experts :[],
                log:[],
                bname:'',
                showAwardBatch:false,
                wtype:'building',
                wtype_title:'房屋建筑工程',
                returnDialogVisible:false,
                returnReason:'',
                returnRow:null,
                smsReasonVisible:false,
                smsReasonText:'',
                smsFailureContactTip:'如通知失败非企业停机、空号、暂停服务、关机、不在服务区的原因造成，请及时联系告知评审办公室。'
			};
		},
		mounted() {
			this.token = "Bearer " + localStorage.getItem("TOKEN");
			var zj_id = localStorage.getItem("zj_id");
			console.log("获取zjinfo",zj_id);
			if(zj_id){
				this.award_id = zj_id;
			}
			this.bname = this.$route.query.bname
			this.searchYear = this.award_batch_id = this.$route.query.award_batch_id != undefined ? this.$route.query.award_batch_id : 0;
			if(this.award_batch_id){
			    localStorage.setItem('gfaward_batch_id',this.award_batch_id);
			} else {
			    this.searchYear = this.award_batch_id = localStorage.getItem('gfaward_batch_id');
			}
		    console.log("获取zjinfo",zj_id);

			if(this.award_id == 17){
				this.searchstatus = '3';
			}
			this.getBatches();
			this.getbatchinfo();
            
			
		},
        computed:{
            scrollerHeight: function() {
                return (window.innerHeight - 250) + 'px'; //自定义高度需求
            },
			isGroupAward() {
				return this.formlist.some(item => item.award_id === 17)
			},
			isApplyAtExpired() {
				if (!this.batchinfo || !this.batchinfo.apply_at || !this.batchinfo.apply_at.length) return false
				const endDate = new Date(this.batchinfo.apply_at[1])
				endDate.setHours(23, 59, 59, 999)
				return new Date() > endDate
			},
            hasReturnedApplications() {
                return this.formlist.some(item => this.isReturnedApplication(item))
            },
            hasPendingDistributableApplications() {
                return this.formlist.some(item => this.canDistribute(item))
            },
            hasIncompleteDistributedApplications() {
                return this.formlist.some(item => this.isPendingReviewApplication(item) && !this.isApplicationFullyDistributed(item))
            },
            hasFullyDistributedApplications() {
                return this.formlist.some(item => this.isPendingReviewApplication(item) && this.isApplicationFullyDistributed(item))
            },
            canFinishDistribute() {
                return this.is_auto_distribute == 1 && (this.hasPendingDistributableApplications || this.hasReturnedApplications || this.hasFullyDistributedApplications)
            }
        },
		methods: {
			getGongfaRegisterProvince(info, row) {
				const value = info || {};
				return value.gf_province_detail
					|| (row && row.register_province)
					|| value.register_province
					|| (Number(value.gf_province || (row && row.gf_province)) === 1 ? '贵州省' : '-');
			},
			formatGongfaAuthors(info) {
				const authors = info && Array.isArray(info.author_names) ? info.author_names : [];
				const names = authors.map(author => author && author.name).filter(Boolean);
				return names.length ? names.join('、') : '-';
			},
		    handleDistructInfo(){
		        this.wtype_title = this.activewtype;
		        this.wtype = this.activewtype == '房屋建筑工程' ? 'building' : (this.activewtype == '土木工程' ? 'civil' : 'industry')
		        this.showAwardBatch = true;
		    },
		    toBatch(){
		          this.$router.push(`/gfprize/Awardbatch`)
		    },
		    confirmauto(){
		      this.auto_distribute = false;
		      this.show_distribute=false;
		      console.log('confirmauto');
		      window.location.reload();
		      this.initList(1);
		    },
		    handleBatch(){
		        localStorage.setItem('gfaward_batch_id',this.award_batch_id);
		        this.initList(1);
		    },
		    async confirmDistribute(){
		        gfdistribute(this.log['id'],{'mainexpert':this.mainexpert,'reexpert':this.reexpert}).then(res => {
                   console.log('res ',res)
                    this.$message({
                        message: "分配成功",
                        type: "success",
                    })
                     this.initList(1);
                    setTimeout(function() {
                        window.location.reload();
                    }, 1000);
                   
                }).catch(error => {
					 console.log('error',error)
                    this.$message({
                        message: error,
                        type: "warning",
                    })
				});
		    },
		    toDistribute(log){
                if (!this.canDistribute(log)) {
                    this.$message.warning('已退回的申请记录不再分配专家');
                    return;
                }
		        this.log = log;
		        console.log('leader',log.leader);
		        console.log('mainexpert',log.mainexpert);
		        console.log('reexpert',log.reexpert);
		        
		        var leader_id = log.leader ? log.leader['expert_id']:0;
		        this.mainexpert = log.mainexpert ? log.mainexpert['expert_id']:0;
		        this.reexpert = log.reexpert ? log.reexpert['expert_id']:0;
		        this.selectedexperts = [this.mainexpert,this.reexpert];
		        let unit  = log['content']['info']['unit'];
		        var experts = [];
		        for(var i = 0; i < this.batch_experts.length ; i++){
		            if(this.batch_experts[i]['unit'] != unit && this.batch_experts[i]['id'] != leader_id){
		                experts.push(this.batch_experts[i])
		            }
		        }
		        console.log('this.batch_experts',this.batch_experts)
		        this.experts = experts;
		        this.show_row_distribute_dialog = true;
		    },
		    handleSelectedExpert(){
		       this.selectedexperts  = [this.mainexpert,this.leader,this.reexpert];
		    },
		    async toSetChecked(){
                if (this.hasReturnedApplications) {
                    this.$message.warning('存在已退回的申请记录，不能进入专家审核');
                    return;
                }
                if (this.hasIncompleteDistributedApplications) {
                    this.$message.warning('存在未分配主审/副审/组长的申请记录，不能进入专家审核');
                    return;
                }
                if (!this.hasFullyDistributedApplications) {
                    this.$message.warning('当前没有已完整分配的申请记录');
                    return;
                }
		        this.$confirm("确认已完成分配,进入专家审核？")
                    .then((_) => {
                        setexpertchecked(this.award_batch_id,{wtype:this.activewtype}).then(res => {
                            this.$message({
                                message: "审核成功",
                                type: "success",
                            })
                            window.location.reload();
                        }).catch(error => {
                            this.$message({
                                message: error,
                                type: "warning",
                            })
                        })
                    })
                    .catch((_) => {});
		    },
		    async getbatchinfo(){
		        this.batchinfo = await batchinfo(this.award_batch_id);
		        console.log('this.activewtype',this.activewtype.indexOf('房屋') )
		        console.log('this.activewtype',this.activewtype)
		        console.log("expertlists",this.batchinfo['expertlists'])
		        if(this.batchinfo['expertlists'].length){
		            this.batch_experts = this.activewtype.indexOf('房屋') != -1 ? this.batchinfo['expertlists'][0]: ( this.activewtype.indexOf('土木') != -1 ? this.batchinfo['expertlists'][1] : this.batchinfo['expertlists'][2]);
		        }
		        		        console.log("batch_experts",this.batch_experts)

		        this.is_auto_distribute = this.batchinfo['is_auto_distribute'];
		    },
		    async confirmAutoDistribute(){
		       await avgdistruct(this.award_batch_id,{wtype:this.activewtype}).then(res => {
                   console.log('res ',res)
                   this.dret = res;
                    this.$message({
                        message: "分配成功",
                        type: "success",
                    })
                    this.show_distribute = true;
                    // setTimeout(function() {
                    //     window.location.reload();
                    // }, 1000);
                }).catch(error => {
					 console.log('error',error)
                    this.$message({
                        message: error,
                        type: "warning",
                    })
				});
		        
		        
		    },
		    //自动分配专家
		    handleDistruct(){
		        this.auto_distribute = true;  
		    },
            async getBatches(){
                let res = await AwardBatches(this.award_id);
                console.log('res.data',res)
                this.batches = res;
                if(this.award_batch_id == 0 ){
                    this.award_batch_id = this.batches.length ? this.batches[0]['id'] : '';
                    localStorage.setItem('gfaward_batch_id',this.award_batch_id);
                }
                
                this.initList(1);
            },
            handlewtype(){
                this.getbatchinfo();
                this.initList(1);
            },
			//分页
			getIndex($index) {
			    return $index + 1;
			},
			getpageValue(index) {
				this.initList(index);
			},
            
            handleUnitClose(done) {
                done();
            },
			handleClose(done) {
				this.$confirm("确认关闭？")
					.then((_) => {
						done();
					})
					.catch((_) => {});
			},
            isReturnedApplication(row) {
                if (!row) return false
                const status = Number(row.status)
                if (status === 7 || status === 8 || status === 9) return true
                if (row.admin_reject_reason || row.admin_rejected_at || row.expert_rejected_at) return true
                return false
            },
            getStatusText(status) {
                const statusMap = {
                    1: '待分配',
                    2: '初审中',
                    3: '待中审',
                    4: '待终审',
                    5: '终审通过',
                    6: '终审退回',
                    7: '已退回',
                    8: '已退回',
                    9: '超时终止',
                }
                return statusMap[Number(status)] || '未知状态'
            },
            getStatusColor(status) {
                const colorMap = {
                    1: '#194ABE',
                    2: '#E6A23C',
                    3: '#194ABE',
                    4: '#194ABE',
                    5: '#67C23A',
                    6: '#E6A23C',
                    7: '#595959',
                    8: '#595959',
                    9: '#F56C6C',
                }
                return colorMap[Number(status)] || '#909399'
            },
            canDistribute(row) {
                if (!row) return false
                if (this.is_auto_distribute != 1) return false
                if (this.isReturnedApplication(row)) return false
                return Number(row.status) < 2
            },
            isPendingReviewApplication(row) {
                if (!row) return false
                if (this.isReturnedApplication(row)) return false
                return Number(row.status) < 2
            },
            isApplicationFullyDistributed(row) {
                return !!(row && row.mainexpert && row.reexpert && row.leader)
            },
            getRowClassName({ row }) {
                return this.isReturnedApplication(row) ? 'returned-application-row' : ''
            },
            canReturnBeforeDistribute(row) {
                if (!row) return false
                if (this.isReturnedApplication(row)) return false
                if (Object.prototype.hasOwnProperty.call(row, 'can_admin_reject')) {
                    return row.can_admin_reject === true || row.can_admin_reject === 1
                }
                const status = Number(row.status)
                return status < 2 && !row.mainexpert && !row.reexpert && !row.leader
            },
            openReturnDialog(row) {
                this.returnRow = row
                this.returnReason = ''
                this.returnDialogVisible = true
            },
            submitReturn() {
                if (!this.returnRow || !this.returnRow.id) return
                adminRejectAwardLog(this.returnRow.id, {
                    award_batch_id: this.award_batch_id,
                }).then(() => {
                    this.$message.success('退回成功')
                    this.returnDialogVisible = false
                    this.initList(1)
                }).catch((err) => {
                    this.$message.error(err && err.message ? err.message : err)
                })
            },
            getSmsStatusText(row) {
                const status = row && (row.return_sms_status || row.sms_status)
                if (status === 1 || status === 'success') return '成功'
                if (status === 2 || status === 'failed' || (row && row.sms_failed_reason)) return '失败'
                if (status === 0 || status === 'pending' || status === 'sending') return '发送中'
                return '-'
            },
            isSmsFailed(row) {
                const status = row && (row.return_sms_status || row.sms_status)
                return !!(row && row.sms_failed_reason) || status === 2 || status === 'failed'
            },
            showSmsReason(row) {
                const fallback = row && row.sms_failed_reason ? row.sms_failed_reason : '暂无失败原因'
                this.smsReasonText = fallback
                this.smsReasonVisible = true
                if (!row || !row.id) return
                getReturnSmsReason(row.id).then((res) => {
                    this.smsReasonText = res && (res.reason || res.message || res.error) ? (res.reason || res.message || res.error) : fallback
                }).catch(() => {
                    this.smsReasonText = fallback
                })
            },
			async initList(page) {
				const data = {
					pageSize: this.pageSize,
					page: page,
					award_id: this.award_id,
					//status: 1,
					wtype:this.activewtype,
					dates:this.dates
				};
                if(this.award_batch_id){
                    data.award_batch_id = this.award_batch_id;
                }
                if(this.keyword){
                    data.keyword = this.keyword;
                }
				let res = await expertaward(data);
                this.loading = false;
				this.formlist = res.data || [];
				this.formlist.forEach(e => {
					let year = e.created_at.slice(0, 4);
					e.year = e.award_batch.year+'-'+e.award_batch.batch;//(parseInt(year) - 1) + '-' + year;
                    if(e.award_id!=9||e.no==0){
                        e.no = e.id;
                    }
				})
				this.total = res.total;
                console.log(this.formlist);
			},
			getvalue() {
				this.step = 0;
				this.ischage = false;
				this.subtitle = "";
			},
			
			async toDetail(obj) {
				console.log('detail',obj)
                this.id = obj.id;
				this.parameters = obj.content || {}
				const { award } = obj
				this.temformlist[0] = obj;
				this.ischage = true;
				this.curObj = obj
                this.temSupplementlist = [];
				this.temUnitlist = [];
				const info = this.parameters.info || {};
				const fileUrl = (field) => {
					const files = Array.isArray(info[field]) ? info[field] : (info[field] ? [info[field]] : []);
					return files[0] && files[0].url ? files[0].url : '';
				};
                //this.checkedlogs = obj.checkedlogs;
                // if(obj.file_urls != undefined){
                //     if(obj.file_urls){
                //         let arr = obj.file_urls.split('$$');
                //         console.log('arr',arr);
                //         for(let i=0,j=arr.length;i<j;i++){
                //             let temArr = arr[i].split(',');
                //             this.temSupplementlist.push({'name':temArr[0],'url':temArr[1]})
                //         }
                //     }
                // }
				this.temUnitlist.push({'name':'贵州省级工法申报汇总表（PDF）','url':fileUrl('filelist1')});
				this.temUnitlist.push({'name':'贵州省级工法申报汇总表（EXCEL）','url':fileUrl('filelist2')});
				this.temUnitlist.push({'name':'贵州省级工法申报表（附件1）','url':fileUrl('filelist3')});
				this.temUnitlist.push({'name':'工法申报承诺书','url':fileUrl('filelist_commitment')});
				this.temUnitlist.push({'name':'工法文本','url':fileUrl('filelist4')});
				this.temUnitlist.push({'name':'企业工法证明材料','url':fileUrl('filelist5')});
				this.temUnitlist.push({'name':'工法关键技术鉴定的有关资料','url':fileUrl('filelist6')});
				this.temUnitlist.push({'name':'工程应用证明','url':fileUrl('filelist7')});
				this.temUnitlist.push({'name':'经济效益证明','url':fileUrl('filelist8')});
				this.temUnitlist.push({'name':'科技查新报告','url':fileUrl('filelist9')});
				this.temUnitlist.push({'name':'涉及他方专利的无争议声明书','url':fileUrl('filelist10')});
				this.temUnitlist.push({'name':'关键技术标准、专利证书、科技成果获奖证明等其他有关材料','url':fileUrl('filelist11')});
				(Array.isArray(info.filelist12) ? info.filelist12 : [info.filelist12]).forEach((file, index) => {
					if (!file || !file.url) return;
					const value = `${file.name || ''} ${file.url}`.toLowerCase();
					const type = /\.(mp4|avi|flv)(?:$|[?#])/.test(value) ? '视频' : '照片';
					this.temUnitlist.push({'name': `工法应用${type}${index + 1}`, 'url': file.url});
				});
                
				this.step = 1;

			},
            toUnitDetail(obj){
                console.log(obj,'toUnitDetail')
                this.unit = obj;
                this.dialogUnitVisible = true;
            },
			
            resetQuery() {
                this.searchYear = '';
                this.keyword = '';
                this.award_id = 0;
                this.loading = true;
                this.initList(1);
            },
            handleQuery(){
                this.loading = true;
                this.initList(1);
            },
            dateFormat(date,fmt) {
                let ret
                const opt = {
                    'y+': date.getFullYear().toString(), // 年
                    'M+': (date.getMonth() + 1).toString(), // 月
                    'd+': date.getDate().toString(), // 日
                    'H+': date.getHours().toString(), // 时
                    'm+': date.getMinutes().toString(), // 分
                    's+': date.getSeconds().toString(), // 秒
                    // 有其他格式化字符需求可以继续添加，必须转化成字符串
                }
                for (let k in opt) {
                    ret = new RegExp('(' + k + ')').exec(fmt)
                    if (ret) {
                        fmt = fmt.replace(
                            ret[1],
                            ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0')
                        )
                    }
                }
                return fmt
            }
		},
	};
</script>

<style>
	.el-tabs__header {
		width: 100% !important;
	}
    .divZJ{
        text-align: left;overflow:auto;
    }
</style>
<style lang="less" scoped>
.form_title {
    align-items: center;
}
.binfobase .my_form2 {
    margin-bottom:0px !important;
    height: auto !important;
    margin-bottom: 0px !important;
    border-bottom: 1px solid #DDD;
     padding-top: 0px !important; 
     padding-bottom: 0px !important; 
    padding-left: 20px;
    
}
.binfobase .form_title {
    width: 150px !important;
        border-right: 1px solid #ddd;
    height: 50px !important;
    line-height: 50px  !important;
}
.binfobase .form_content {
        padding-left: 10px;
        height: 50px;
    line-height: 50px;
        
}
.batchsearch input {
    border:0px !important;
}
.topnavs {
        position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    border-bottom: 1px solid #DDDDDD;
}
.drtitle {
    font-weight: 400;
    font-size: 14px;
    color: #262626;
    text-align: left;
    margin-top:10px;
}
.drth,.drtr {
    display: flex;
    flex-direction: row;
    background: #F5F5F5;
    border: 0.5px solid #DDDDDD;
}
.drtr {
    background: #FFFFFF;
}

.drth div {
    flex:1;
    font-weight: 400;
    font-size: 16px;
    color: #262626;
    text-align: center;
    padding-top:12px;
    padding-bottom:12px;
    border: 0.5px solid #DDDDDD;
}
.drtr div {
    flex:1;
    font-weight: 400;
    font-size: 18px;
    color: #262626;
    text-align: center;
    padding-top:12px;
    padding-bottom:12px;
    border: 0.5px solid #DDDDDD;
    border-top:0px;
}

/deep/ .el-table .returned-application-row > td {
    background: #f5f7fa !important;
    color: #a0a6ad !important;
}

/deep/ .el-table .returned-application-row .cell {
    color: #a0a6ad !important;
}

/deep/ .el-table .returned-application-row .el-button {
    opacity: 0.55;
}
	/deep/.block-title {
		border-left: 3px solid #194abe !important;
	}

	.yellow-box {
		height: 40px;
		background: #FEF8EF;
		opacity: 1;
		border-radius: 6px 6px 0px 0px;
		display: flex;
		align-items: center;
		justify-content: space-evenly;

		span {
			font-size: 16px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			line-height: 24px;

			&:nth-child(1) {
				color: #194ABE;
			}

			&:nth-child(2) {
				color: #0C0D0F;
			}

			&:nth-child(3) {
				color: #7C828A;
				font-size: 14px;
			}
		}
	}

	.reason {
		margin-top: 20px;
		width: 100%;
		height: 162px;
		background: #FFFFFF;
		border: 1px solid #BDC3CB;
		opacity: 1;
		border-radius: 4px;
		outline: none;
		padding: 10px;
		box-sizing: border-box;
	}

	.textarea {
		width: 382px;
		// height: 92px;
		background: #ffffff;
		border: 1px solid #bdc3cb;
		opacity: 1;
		border-radius: 4px;
	}

	.block-list {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		margin: 20px 0;

		&-item {
			width: 370px;
			background: #ffffff;
			border: 1px dashed #c8cdd5;
			padding: 24px 25px;
			display: flex;
			justify-content: space-between;
			align-items: flex-end;
			margin-bottom: 21px;
			position: relative;

			&-r-t {
				position: absolute;
				top: 0;
				right: 0;
				width: 73px;
				height: 27px;
				background: #f5f9fb;
				opacity: 1;
				border-radius: 0px 0px 0px 80px;
				font-size: 16px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				line-height: 27px;
				color: #c6c9ce;
				padding-left: 10px;
				box-sizing: border-box;
			}

			&-box {
				display: flex;
				flex-direction: column;
				justify-content: space-evenly;
				align-items: flex-start;

				&-t {
					width: 244px;
					color: #0c0d0f;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
					overflow: hidden;
					text-align: justify;
					font-size: 20px;
					font-family: Source Han Sans CN;
					font-weight: 400;
				}

				&-dtae {
					font-size: 14px;
					font-family: Source Han Sans CN;
					font-weight: bold;
					line-height: 26px;
					color: #194abe;
				}

				&-startend {
					font-size: 14px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					line-height: 26px;
					color: #7c828a;
				}

				&-b {
					width: 91px;
					height: 32px;
					background: #ffffff;
					border: 1px solid #194abe;
					color: #194abe;
					opacity: 1;
					border-radius: 6px;
					text-align: center;
					line-height: 32px;
					font-size: 14px;
					cursor: pointer;
				}

				&-b-d {
					background: #ffffff !important;
					border: 1px solid #d4dbdd !important;
					color: #c8cdd5 !important;
				}

				&-b-s {
					background: #d4dbdd !important;
					border: 1px solid #d4dbdd !important;
					color: #ffffff !important;
				}
			}
		}
	}

	.margin-bottom-40 {
		margin-bottom: 40px;
	}

	.infor {
		padding-bottom: 40px;
		min-height: 800px;
		margin-bottom: 34px;
		position: relative;
	}

	.upload-demo {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
	}

	.uploadheader {
		height: 60px;
		width: 100%;
		display: flex;
		align-items: center;

		span {
			margin-right: 10px;
			color: #71767c;
		}
	}

	.margin-top-40 {
		margin-top: 40px;
	}

	.block-solid {
		width: 100%;
		height: 2px;
		background-color: #e51725;
		margin-top: 30px;
	}

	.shenhjrkr {
		margin: 71px 0 100px 0;

		img {
			width: 120px;
		}
	}
	.block-addr {
		display: inline-block;
		padding: 13px 32px;
		background-color: #fff7e8;
		font-size: 14px;
		margin-top: 31px;

		.span-l {
			color: #9fa5ae;
		}

		.span-r {
			color: #194abe;
		}
	}
	.pform_title {
	    font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 700;
        line-height: 20px;
        color: #0c0d0f;
        text-align: left;
	}
	.form_right {
	      width: 860px;
	      .flex {
	        display: flex;
	      }
	      .flex-direction {
	        flex-direction: column;
	      }
	      .form_1 {
	        width: 100%;
	        background: #ffffff;
	        padding: 35px 30px;
	        box-sizing: border-box;
	        margin-bottom: 30px;
	        border-radius: 6px;

			.form_dec {
				text-align: left;
				margin-top: 20px;
			}

	        .border {
	          border-top: 1px dashed #9fa5ae;
	          margin: 20px 0;
	        }
	        .bord {
	          margin-top: 11px;
	          width: 858px;
	          height: 0px;
	          border: 1px solid #194abe;
	          position: relative;
	          img {
	            width: 11px;
	            height: 6px;
	            position: absolute;
	            top: -6px;
	            left: 37px;
	          }
	        }
	        .newlybuild {
	          margin: 0 auto;
	          cursor: pointer;
	          width: 221px;
	          height: 36px;
	          border: 2px solid #194abe;
	          border-radius: 4px;
	          display: flex;
	          justify-content: center;
	          align-items: center;
	          img {
	            width: 16px;
	            height: 16px;
	            margin-right: 7px;
	          }
	          p {
	            font-size: 14px;
	            font-family: Microsoft YaHei;
	            font-weight: 400;
	            line-height: 14px;
	            color: #194abe;
	          }
	        }
	        .form_box_content {
	          width: 100%;
	          .form_title {
	            box-sizing: border-box;
	            text-align: start;
	            display: flex;
	            p {
	              font-size: 16px;
	              font-family: Microsoft YaHei;
	              font-weight: bold;
	              line-height: 20px;
	              color: #0c0d0f;
	            }
	            .delete_icon {
	              cursor: pointer;
	              margin-left: 10px;
	              width: 61px;
	              height: 25px;
	              background: #ffffff;
	              border: 1px solid #f9656f;
	              opacity: 1;
	              border-radius: 6px;
	              display: flex;
	              align-items: center;
	              justify-content: space-evenly;
	              img {
	                width: 13px;
	                height: 14px;
	              }
	              p {
	                font-size: 14px;
	                font-family: Source Han Sans CN;
	                font-weight: 400;
	                line-height: 20px;
	                color: #f9656f;
	              }
	            }
	          }
	        }
	      }
	    }

	.flex {
	    display: flex;
	    align-items: center;
	  }
	  .my_form,
	  .my_form2 {
	    width: 100%;
	    height: 100%;
	    display: flex;
	    overflow: visible;
	    align-items: stretch;
		margin-bottom: 30px;
	    .form_title {
	      width: 80px;
	      min-width: 80px;
	      height: auto;
	      display: flex;
	      justify-content: left;
	      font-size: 14px;
	      font-family: Microsoft YaHei;
	      font-weight: 400;
	      line-height: 20px;
	      box-sizing: border-box;
	      color: #808895;
	    }
	    .form_content,
	    .form_long,
	    .form_content {
			color:#323232;
			font-family: PingFang SC-Regular, PingFang SC;
			font-weight: 400;
			font-size: 14px;
	      position: relative;
		  padding-right: 6px;
		  text-align:left;
		  width:230px;
	    }
		.form_textarea{
			color:#323232;
			font-family: PingFang SC-Regular, PingFang SC;
			font-weight: 400;
			font-size: 14px;
	      position: relative;
		  padding-right: 6px;
		  text-align:left;
		}
	  }
      .a01{
          color:#000;
      }
      .a01:hover{
          color:#194ABE;
          text-decoration:underline;
      }
      .a01:visited{
          color:#000;
      }
      .span02{
          font-weight: 400;
          color: #37C8AA;
          margin-left: 5px;
      }
      .span03{
          color: #B0B6C1;
          font-weight: 400;
      }
	  .spanText{
		  margin-top:25px;
		  font-size: 16px;
		  font-family: PingFang SC-Semibold, PingFang SC;
		  font-weight: 600;
		  color: #194ABE;
		  line-height: 0px;
		  -webkit-background-clip: text;
	  }
      .radio01{
          background:#F5F6F7;
          margin-bottom:15px;
          border: none !important;
          width:100px;
          margin-left: 10px;
          margin-right: 10px;
          white-space: nowrap;
          display: inline-block;
          overflow: hidden;
      }
      .pos-page {
      	position: absolute;
      	bottom: 0px !important;
      	width: 100%;
      }

      .infor {
          width: 1050px !important;
      }
      .w-1200 {
          width: 1500px  !important;
          margin: 0 auto;
      }
      .infor-t-r {
        width: 104px;
        height: 31px;
        border: 1px solid #7c828a;
        background: #194abe;
        color: #fff;
        border-radius: 5px;
        opacity: 1;
        overflow: hidden;
        display: table-cell;
        line-height: 31px;
        cursor: pointer
    }
    
    .infor-t-r img{
        vertical-align: middle
    }
    
    .infor-t-r span{
        font-size: 14px
    }
</style>
